<h2>WYNIKI TURNIEJÓW LOKALNYCH</h2>
<div class="ui-g">
<div class="ui-g-6 ui-md-4 ui-lg-2"  *ngFor="let t of lokalneturnieje">
  <app-wynikilokalnego [turniej]="t"></app-wynikilokalnego>
</div>
</div>

